import React from 'react';
import CiberCracontent from '../components/CiberCraContent';
import Footer from '../components/footer';

const CiberCrapage = () => {
  return (
    <div className="Ciberseg">
       
          <CiberCracontent />
          <Footer />
    </div>
  );
}

export default CiberCrapage;